import * as React from 'react';

import { KeyValueRow, type KeyValueRowProps, KeyValueTable, Text } from '@/design-system/components/ui';
import { cn } from '@/design-system/lib/utils';

export interface DetailSectionProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title: React.ReactNode;
  headerAction?: React.ReactNode;
}

const DetailSection = React.forwardRef<HTMLElement, DetailSectionProps>(
  ({ title, headerAction, className, children, ...props }, ref) => (
    <section ref={ref} className={cn('tw:flex tw:flex-col tw:gap-2', className)} {...props}>
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-2">
        <Text variant="body-sm" color="muted" className="tw:uppercase tw:tracking-wide">
          {title}
        </Text>
        {headerAction}
      </div>
      <KeyValueTable>{children}</KeyValueTable>
    </section>
  ),
);

DetailSection.displayName = 'DetailSection';

export type DetailSectionRowProps = KeyValueRowProps;
const DetailSectionRow = KeyValueRow;

export { DetailSection, DetailSectionRow };
